import Re, { createContext as M, useContext as Y, useState as Ve, useCallback as A, useLayoutEffect as Te, useEffect as oe, useMemo as Me, useReducer as Ae } from "react";
import Ye from "md5";
import We from "pusher-js";
const Ce = M(() => {
  console.warn("activity monitor context is not ready");
}), it = () => Y(Ce);
var be, re = { exports: {} }, F = {}, ge, Ee, Pe = {};
function ze() {
  return ge || (ge = 1, t = Pe, process.env.NODE_ENV !== "production" && (function() {
    var n = Re, o = 60103, d = 60106;
    t.Fragment = 60107;
    var r = 60108, c = 60114, _ = 60109, p = 60110, l = 60112, m = 60113, i = 60120, T = 60115, v = 60116, g = 60121, k = 60122, ae = 60117, ie = 60129, se = 60131;
    if (typeof Symbol == "function" && Symbol.for) {
      var P = Symbol.for;
      o = P("react.element"), d = P("react.portal"), t.Fragment = P("react.fragment"), r = P("react.strict_mode"), c = P("react.profiler"), _ = P("react.provider"), p = P("react.context"), l = P("react.forward_ref"), m = P("react.suspense"), i = P("react.suspense_list"), T = P("react.memo"), v = P("react.lazy"), g = P("react.block"), k = P("react.server.block"), ae = P("react.fundamental"), P("react.scope"), P("react.opaque.id"), ie = P("react.debug_trace_mode"), P("react.offscreen"), se = P("react.legacy_hidden");
    }
    var ce = typeof Symbol == "function" && Symbol.iterator, V = n.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function C(e) {
      for (var u = arguments.length, s = new Array(u > 1 ? u - 1 : 0), S = 1; S < u; S++) s[S - 1] = arguments[S];
      (function(b, y, h) {
        var E = V.ReactDebugCurrentFrame, O = "";
        if (D) {
          var L = I(D.type), w = D._owner;
          O += (function(a, R, U) {
            var N = "";
            if (R) {
              var z = R.fileName, H = z.replace(X, "");
              if (/^index\./.test(H)) {
                var x = z.match(X);
                if (x) {
                  var _e = x[1];
                  _e && (H = _e.replace(X, "") + "/" + H);
                }
              }
              N = " (at " + H + ":" + R.lineNumber + ")";
            } else U && (N = " (created by " + U + ")");
            return `
    in ` + (a || "Unknown") + N;
          })(L, D._source, w && I(w.type));
        }
        (O += E.getStackAddendum()) !== "" && (y += "%s", h = h.concat([O]));
        var f = h.map(function(a) {
          return "" + a;
        });
        f.unshift("Warning: " + y), Function.prototype.apply.call(console[b], console, f);
      })("error", e, s);
    }
    var X = /^(.*)[\\\/]/, je = 1;
    function I(e) {
      if (e == null) return null;
      if (typeof e.tag == "number" && C("Received an unexpected object in getComponentName(). This is likely a bug in React. Please file an issue."), typeof e == "function") return e.displayName || e.name || null;
      if (typeof e == "string") return e;
      switch (e) {
        case t.Fragment:
          return "Fragment";
        case d:
          return "Portal";
        case c:
          return "Profiler";
        case r:
          return "StrictMode";
        case m:
          return "Suspense";
        case i:
          return "SuspenseList";
      }
      if (typeof e == "object") switch (e.$$typeof) {
        case p:
          return "Context.Consumer";
        case _:
          return "Context.Provider";
        case l:
          return S = e, b = e.render, y = "ForwardRef", h = b.displayName || b.name || "", S.displayName || (h !== "" ? y + "(" + h + ")" : y);
        case T:
          return I(e.type);
        case g:
          return I(e.render);
        case v:
          var u = (s = e)._status === je ? s._result : null;
          if (u) return I(u);
      }
      var s, S, b, y, h;
      return null;
    }
    var le = {};
    V.ReactDebugCurrentFrame;
    var D = null;
    function W(e) {
      D = e;
    }
    var ue, fe, de = V.ReactCurrentOwner, Z = Object.prototype.hasOwnProperty, Ue = { key: !0, ref: !0, __self: !0, __source: !0 };
    function De(e, u, s, S, b) {
      var y, h = {}, E = null, O = null;
      for (y in s !== void 0 && (E = "" + s), (function(f) {
        if (Z.call(f, "key")) {
          var a = Object.getOwnPropertyDescriptor(f, "key").get;
          if (a && a.isReactWarning) return !1;
        }
        return f.key !== void 0;
      })(u) && (E = "" + u.key), (function(f) {
        if (Z.call(f, "ref")) {
          var a = Object.getOwnPropertyDescriptor(f, "ref").get;
          if (a && a.isReactWarning) return !1;
        }
        return f.ref !== void 0;
      })(u) && (O = u.ref, (function(f) {
        typeof f.ref == "string" && de.current;
      })(u)), u) Z.call(u, y) && !Ue.hasOwnProperty(y) && (h[y] = u[y]);
      if (e && e.defaultProps) {
        var L = e.defaultProps;
        for (y in L) h[y] === void 0 && (h[y] = L[y]);
      }
      if (E || O) {
        var w = typeof e == "function" ? e.displayName || e.name || "Unknown" : e;
        E && (function(f, a) {
          var R = function() {
            ue || (ue = !0, C("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", a));
          };
          R.isReactWarning = !0, Object.defineProperty(f, "key", { get: R, configurable: !0 });
        })(h, w), O && (function(f, a) {
          var R = function() {
            fe || (fe = !0, C("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", a));
          };
          R.isReactWarning = !0, Object.defineProperty(f, "ref", { get: R, configurable: !0 });
        })(h, w);
      }
      return (function(f, a, R, U, N, z, H) {
        var x = { $$typeof: o, type: f, key: a, ref: R, props: H, _owner: z, _store: {} };
        return Object.defineProperty(x._store, "validated", { configurable: !1, enumerable: !1, writable: !0, value: !1 }), Object.defineProperty(x, "_self", { configurable: !1, enumerable: !1, writable: !1, value: U }), Object.defineProperty(x, "_source", { configurable: !1, enumerable: !1, writable: !1, value: N }), Object.freeze && (Object.freeze(x.props), Object.freeze(x)), x;
      })(e, E, O, b, S, de.current, h);
    }
    var Q, ee = V.ReactCurrentOwner;
    function $(e) {
      D = e;
    }
    function te(e) {
      return typeof e == "object" && e !== null && e.$$typeof === o;
    }
    function pe() {
      if (ee.current) {
        var e = I(ee.current.type);
        if (e) return `

Check the render method of \`` + e + "`.";
      }
      return "";
    }
    V.ReactDebugCurrentFrame, Q = !1;
    var ye = {};
    function ve(e, u) {
      if (e._store && !e._store.validated && e.key == null) {
        e._store.validated = !0;
        var s = (function(b) {
          var y = pe();
          if (!y) {
            var h = typeof b == "string" ? b : b.displayName || b.name;
            h && (y = `

Check the top-level render call using <` + h + ">.");
          }
          return y;
        })(u);
        if (!ye[s]) {
          ye[s] = !0;
          var S = "";
          e && e._owner && e._owner !== ee.current && (S = " It was passed a child from " + I(e._owner.type) + "."), $(e), C('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', s, S), $(null);
        }
      }
    }
    function he(e, u) {
      if (typeof e == "object") {
        if (Array.isArray(e)) for (var s = 0; s < e.length; s++) {
          var S = e[s];
          te(S) && ve(S, u);
        }
        else if (te(e)) e._store && (e._store.validated = !0);
        else if (e) {
          var b = (function(E) {
            if (E === null || typeof E != "object") return null;
            var O = ce && E[ce] || E["@@iterator"];
            return typeof O == "function" ? O : null;
          })(e);
          if (typeof b == "function" && b !== e.entries) for (var y, h = b.call(e); !(y = h.next()).done; ) te(y.value) && ve(y.value, u);
        }
      }
    }
    function $e(e) {
      var u, s = e.type;
      if (s != null && typeof s != "string") {
        if (typeof s == "function") u = s.propTypes;
        else {
          if (typeof s != "object" || s.$$typeof !== l && s.$$typeof !== T) return;
          u = s.propTypes;
        }
        if (u) {
          var S = I(s);
          (function(b, y, h, E, O) {
            var L = Function.call.bind(Object.prototype.hasOwnProperty);
            for (var w in b) if (L(b, w)) {
              var f = void 0;
              try {
                if (typeof b[w] != "function") {
                  var a = Error((E || "React class") + ": " + h + " type `" + w + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof b[w] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                  throw a.name = "Invariant Violation", a;
                }
                f = b[w](y, w, E, h, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
              } catch (R) {
                f = R;
              }
              !f || f instanceof Error || (W(O), C("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", E || "React class", h, w, typeof f), W(null)), f instanceof Error && !(f.message in le) && (le[f.message] = !0, W(O), C("Failed %s type: %s", h, f.message), W(null));
            }
          })(u, e.props, "prop", S, e);
        } else s.PropTypes === void 0 || Q || (Q = !0, C("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", I(s) || "Unknown"));
        typeof s.getDefaultProps != "function" || s.getDefaultProps.isReactClassApproved || C("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function me(e, u, s, S, b, y) {
      var h = (function(a) {
        return typeof a == "string" || typeof a == "function" || a === t.Fragment || a === c || a === ie || a === r || a === m || a === i || a === se || typeof a == "object" && a !== null && (a.$$typeof === v || a.$$typeof === T || a.$$typeof === _ || a.$$typeof === p || a.$$typeof === l || a.$$typeof === ae || a.$$typeof === g || a[0] === k);
      })(e);
      if (!h) {
        var E, O = "";
        (e === void 0 || typeof e == "object" && e !== null && Object.keys(e).length === 0) && (O += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports."), O += pe(), e === null ? E = "null" : Array.isArray(e) ? E = "array" : e !== void 0 && e.$$typeof === o ? (E = "<" + (I(e.type) || "Unknown") + " />", O = " Did you accidentally export a JSX literal instead of a component?") : E = typeof e, C("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", E, O);
      }
      var L = De(e, u, s, b, y);
      if (L == null) return L;
      if (h) {
        var w = u.children;
        if (w !== void 0) if (S) if (Array.isArray(w)) {
          for (var f = 0; f < w.length; f++) he(w[f], e);
          Object.freeze && Object.freeze(w);
        } else C("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
        else he(w, e);
      }
      return e === t.Fragment ? (function(a) {
        for (var R = Object.keys(a.props), U = 0; U < R.length; U++) {
          var N = R[U];
          if (N !== "children" && N !== "key") {
            $(a), C("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", N), $(null);
            break;
          }
        }
        a.ref !== null && ($(a), C("Invalid attribute `ref` supplied to `React.Fragment`."), $(null));
      })(L) : $e(L), L;
    }
    var He = function(e, u, s) {
      return me(e, u, s, !1);
    }, Fe = function(e, u, s) {
      return me(e, u, s, !0);
    };
    t.jsx = He, t.jsxs = Fe;
  })()), Pe;
  var t;
}
var B = (Ee || (Ee = 1, process.env.NODE_ENV === "production" ? re.exports = (function() {
  if (be) return F;
  be = 1;
  var t = Re, n = 60103;
  if (F.Fragment = 60107, typeof Symbol == "function" && Symbol.for) {
    var o = Symbol.for;
    n = o("react.element"), F.Fragment = o("react.fragment");
  }
  var d = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, r = Object.prototype.hasOwnProperty, c = { key: !0, ref: !0, __self: !0, __source: !0 };
  function _(p, l, m) {
    var i, T = {}, v = null, g = null;
    for (i in m !== void 0 && (v = "" + m), l.key !== void 0 && (v = "" + l.key), l.ref !== void 0 && (g = l.ref), l) r.call(l, i) && !c.hasOwnProperty(i) && (T[i] = l[i]);
    if (p && p.defaultProps) for (i in l = p.defaultProps) T[i] === void 0 && (T[i] = l[i]);
    return { $$typeof: n, type: p, key: v, ref: g, props: T, _owner: d.current };
  }
  return F.jsx = _, F.jsxs = _, F;
})() : re.exports = ze()), re.exports);
const Le = M(void 0), st = () => Y(Le), ke = ({ key: t, defaultValue: n, onExternalUpdate: o }) => {
  const [d, r] = Ve(), c = A(() => {
    if (t) try {
      const m = window.localStorage.getItem(t);
      if (!m) return void r(n);
      const i = JSON.parse(m);
      return r(i), i;
    } catch (m) {
      return void console.error(`Error reading local storage item ${t}:`, m);
    }
  }, [n, t]), _ = A((m) => {
    if (t) try {
      const i = JSON.stringify(m);
      window.localStorage.setItem(t, i), r(m), window.dispatchEvent(new StorageEvent("local-storage", { key: t, newValue: i }));
    } catch (i) {
      console.error(`Error setting local storage item ${t}:`, i);
    }
  }, [t]), p = A(() => {
    t && (window.localStorage.removeItem(t), new StorageEvent("local-storage", { key: t, url: window.location.origin }));
  }, [t]), l = A((m) => {
    o && m.key === t && (console.log(JSON.stringify(m, null, 2)), o(c()));
  }, [t, c, o]);
  return Te(() => {
    c();
  }, [c]), oe(() => (window.addEventListener("local-storage", l), window.addEventListener("storage", l), () => {
    window.removeEventListener("local-storage", l), window.removeEventListener("storage", l);
  }), [l]), [d, _, p];
}, q = (t, n) => {
  let o, d = t;
  try {
    let r = n.split(".");
    for (r.length === 0 && (r = [n]); r.length > 0; ) {
      if (o = r.shift(), !o) return;
      if (Array.isArray(d[o])) {
        d = [];
        const c = r.splice(-1).join(".");
        for (let _ = 0, p = t[o].length; _ < p; _++) d.push(q(t[o][_], c));
      } else d = d[o];
    }
    return d;
  } catch (r) {
    return void console.error("unexpected error occurred while trying to find value from pointer", t, n, r);
  }
}, G = (t, n, o) => {
  let d, r = -1;
  for (let c = 0, _ = t?.length; c < _; c += 1) if (d = q(t[c], n), Array.isArray(d)) {
    if (d.indexOf(o) !== -1) {
      r = c;
      break;
    }
  } else if (d === o) {
    r = c;
    break;
  }
  return r;
}, we = (t, n) => [...t].sort((o, d) => {
  let r = q(o, n.toString()), c = q(d, n.toString());
  return typeof r == "string" && (r = r.toLocaleLowerCase()), typeof c == "string" && (c = c.toLocaleLowerCase()), r === c ? 0 : r < c ? -1 : 1;
}), ct = ({ partitionKey: t, activityKinds: n, children: o }) => {
  const d = Me(() => n.reduce((p, l) => (p[l.kind] = [], p), { all: [] }), [n]), [r, c] = ke({ key: t, defaultValue: d }), _ = A((p) => {
    if (!r) return void console.warn("unable to add activity: monitor not initialized");
    const l = p.kind;
    if (!(l in r)) return void console.warn(`unable to add activity: unsupported kind: ${p.kind}`, p);
    if (!p.entity.id) return void console.warn("unable to add activity: entity does not have an ID", p);
    const m = (/* @__PURE__ */ new Date()).toJSON();
    let i, T;
    switch (l) {
      case "project":
      case "scenario-interactive":
      case "scenario-rule":
        i = r[l], T = { ...p, visited_at: m };
    }
    const v = G(r[p.kind], "entity.id", p.entity.id);
    if (v === -1) i.unshift(T), i.length = Math.min(i.length, 10);
    else switch (i[v].visited_at = m, we(i, "visited_at"), l) {
      case "project":
      case "scenario-interactive":
      case "scenario-rule":
        r[l] = i.reverse();
    }
    const g = G(r.all, "entity.id", p.entity.id);
    g === -1 ? (r.all.unshift(T), r.all.length = Math.min(r.all.length, 10)) : (r.all[g].visited_at = m, we(r.all, "visited_at"), r.all = r.all.reverse()), c(r);
  }, [r, c]);
  return B.jsx(Le.Provider, { value: r, children: B.jsx(Ce.Provider, { value: _, children: o }) });
}, lt = { ALL: "all", PROJECT: "project", SCENARIO_INTERACTIVE: "scenario-interactive", SCENARIO_RULE: "scenario-rule" }, ne = () => {
  console.warn("auth context is not ready");
}, Je = M({ isLoading: !0, isAuthenticated: !1, provider: "auth0", availableProviders: ["auth0"], accessToken: void 0, getAccessToken: () => Promise.reject(ne()), login: () => Promise.reject(ne()), logout: ne }), ut = () => Y(Je), Ke = "PUSHER_SET_CONTROLLER", Be = (t, n) => ({ ...t, _controller: n }), qe = "PUSHER_SET_USER_CHANNEL", Ge = (t, n) => ({ ...t, userChannel: n }), Xe = (t, n) => {
  switch (n.type) {
    case Ke:
      return Be(t, n.data);
    case qe:
      return Ge(t, n.data);
  }
}, J = () => {
  console.warn("pusher context is not ready");
}, Ie = { _controller: void 0, userChannel: void 0, initPusher: J, subscribeToPush: J, unsubscribeFromPush: J, shutdownPusher: J }, Ne = M(Ie), ft = () => Y(Ne), dt = ({ children: t }) => {
  const n = { ENV: "staging", HIVEMIND_ENV: "stg.hivery.ai", CY_TEST: "true", JEST: !1, ALLOW_PASSWORD_LOGIN: "true", CURATE_API_V1: "https://stg.hivery.ai/api/v1/curate", CURATE_API_V2: "https://stg.hivery.ai/api/v2/curate", INTERACTIVE_EDIT_API: "https://stg.hivery.ai/api/v1/ie", PREDICTION_API: "https://stg.hivery.ai/api/v1/prediction", SSDI_API: "https://stg.hivery.ai/api/v1/ssdi", SSDI_API_V2: "https://stg.hivery.ai/api/v2/ssdi", STRATEGY_API: "https://stg.hivery.ai/api/v1/strategies", AGENT_API: "https://stg.hivery.ai/api/v1/agent", FILES_API_HOST: "", AUTH0_CLIENT_ID: "gSrXJ9P8FvZdua2q1gYqswVOJqQqRpdd", AUTH0_DOMAIN: "auth.stg.hivery.ai", AUTH0_AUDIENCE: "propel-api-staging", PUSHER_APP_KEY: "ed81ada4152f5becc720", PUSHER_CLUSTER: "us3", PUSHER_IE_APP_KEY: "ed81ada4152f5becc720", PUSHER_IE_CLUSTER: "us3", UNLEASH_URL: "https://zero.hivery.ai/unleash/api/frontend", UNLEASH_TOKEN: "*:development.73b148c1e2fe6b2e0aeedfe610ee2d6e8c5890dea9f00e6a08c8638d", UNLEASH_ENV: "development", OTEL_KEY: "", OTEL_COLLECTOR_URL: "https://stg.hivery.ai/collect", OTEL_SERVICE_NAME: "", PRODUCT_IMAGE_HOST: "prd", AZURE_CDN_DOMAIN: "https://app.stg.hivery.ai" }, [o, d] = Ae(Xe, { ...Ie }), r = A((v) => {
    c({ type: "PUSHER_SET_CONTROLLER", data: v });
  }, [c = d]);
  var c;
  const _ = ((v) => A((g) => {
    v({ type: "PUSHER_SET_USER_CHANNEL", data: g });
  }, [v]))(d), p = A((v, g) => {
    const k = new We(n.PUSHER_APP_KEY, { authEndpoint: `${n.CURATE_API_V1}/pusher/authenticate`, auth: { headers: { Authorization: `Bearer ${v}` } }, cluster: n.PUSHER_CLUSTER, forceTLS: !0 });
    r(k), _(k.subscribe(`private-user-${Ye(g)}`));
  }, [n.CURATE_API_V1, n.PUSHER_APP_KEY, n.PUSHER_CLUSTER, r, _]), l = A((v) => {
    if (!o._controller) return void console.warn("unable to subscribe to notifications: service not ready.");
    const g = o._controller.allChannels();
    if (!g) return o._controller.subscribe(v);
    const k = G(g, "name", v);
    return k === -1 ? o._controller.subscribe(v) : g[k];
  }, [o._controller]), m = A((v) => {
    if (!o._controller) return void console.warn("unable to unsubscribe to notifications: service not ready.");
    const g = o._controller.allChannels();
    g && (G(g, "name", v) !== -1 ? o._controller.unsubscribe(v) : console.warn("unable to unsubscribe: channel was not found", v));
  }, [o._controller]), i = A(() => {
    if (!o._controller) return void console.warn("unable to shutdown notifications: service not ready.");
    const v = o._controller, g = o._controller.allChannels();
    g && g.forEach((k) => {
      v.unsubscribe(k.name);
    });
  }, [o._controller]), T = { ...o, initPusher: p, subscribeToPush: l, unsubscribeFromPush: m, shutdownPusher: i };
  return B.jsx(Ne.Provider, { value: T, children: t });
}, Ze = "THEME_SET_MODE", Qe = (t, n) => ({ ...t, mode: n }), et = (t, n) => {
  if (n.type === Ze) return Qe(t, n.data);
}, K = { mode: "light", setMode: () => {
  console.warn("theme context is not ready");
} }, xe = M(K), pt = () => Y(xe), yt = ({ children: t, disabled: n = !0 }) => {
  const [o, d] = Ae(et, { ...K, mode: K.mode }), r = A((i) => {
    c({ type: "THEME_SET_MODE", data: i });
  }, [c = d]);
  var c;
  const [_, p] = ke({ key: "themeMode", defaultValue: K.mode, onExternalUpdate: r }), l = A((i) => {
    document.body.dataset.theme = i, p(i), r(i);
  }, [r, p]), m = { ...o, setMode: l };
  return oe(() => {
    if (n) return document.body.dataset.theme = "", void document.body.classList.remove("bg-surface", "text-on-surface");
    _ !== o.mode && (document.body.classList.add("bg-surface", "text-on-surface"), document.body.dataset.theme = _, r(_));
  }, [n, r, _, o.mode]), Te(() => {
    if (n) return document.body.dataset.theme = "", void document.body.classList.remove("bg-surface", "text-on-surface");
    document.body.classList.add("bg-surface", "text-on-surface"), document.body.dataset.theme = o.mode;
  }, [n, o.mode]), B.jsx(xe.Provider, { value: m, children: t });
}, j = [], vt = (t) => {
  const n = t.navigate.bind(t);
  t.navigate = async (...o) => {
    const d = o;
    if (j.length > 0) {
      const r = j.map((c) => c());
      if (!(await Promise.all(r)).every(Boolean)) return;
    }
    return n(...d);
  }, t.subscribe(async (o) => {
    if (o.historyAction === "POP" && j.length > 0) {
      const d = j.map((r) => r());
      (await Promise.all(d)).every(Boolean) || n(1);
    }
  });
}, Se = (t) => {
  t.preventDefault(), t.returnValue = "";
}, Oe = (t) => {
  t.preventDefault(), t.stopImmediatePropagation(), t.stopPropagation();
}, tt = (t) => (j.length === 0 && (addEventListener("beforeunload", Se, { capture: !0 }), addEventListener("popstate", Oe, { capture: !0 })), j.push(t), () => {
  const n = j.indexOf(t);
  j.splice(n, 1), j.length === 0 && (removeEventListener("beforeunload", Se, { capture: !0 }), removeEventListener("popstate", Oe, { capture: !0 }));
}), rt = (t, n) => {
  oe(() => {
    if (t) return tt(n);
  }, [n, t]);
}, ht = (t, n = !1) => {
  rt(n, A(() => confirm(t), [t]));
};
export {
  lt as ACTIVITY_KINDS,
  ct as ActivityMonitorProvider,
  Je as AuthContext,
  Ne as PusherContext,
  dt as PusherProvider,
  yt as ThemeProvider,
  tt as blockNavigation,
  vt as createRouterObservers,
  it as useActivityMonitorActions,
  st as useActivityMonitorState,
  ut as useAuthContext,
  rt as useBlocker,
  ke as useLocalStorage,
  ht as usePrompt,
  ft as usePusherContext,
  pt as useThemeContext
};
//# sourceMappingURL=mystique.js.map
